document.addEventListener("DOMContentLoaded", function () {
  const menuCategories = document.querySelectorAll(
    ".mega-menu__list-content_category"
  );
  const categoryLists = document.querySelectorAll(
    ".mega-menu__list-content_category-list"
  );

  function activateCategory(index, target) {
    document
      .querySelector(".mega-menu__link--active")
      .classList.remove("mega-menu__link--active");
    target.classList.add("mega-menu__link--active");
    categoryLists.forEach((list) => {
      if (list.getAttribute("data-index") === index) {
        list.classList.add("open");
      } else {
        list.classList.remove("open");
      }
    });
  }

  menuCategories.forEach((category) => {
    const index = category.getAttribute("data-index");

    category.addEventListener("mouseenter", function (event) {
      activateCategory(index, event.target);
    });
  });
});
